export type TaskStatus = 'unverified' | 'correct' | 'incorrect' | 'na';

export type TaskGroup =
  | 'tc-area'
  | 'dca-forecasts'
  | 'tc-details'
  | 'verify-volumes'
  | 'ltd-inventory';

export interface ActionMeta {
  category: string;
  label: string;
  description: string;
  previousValue?: string;
  newValue?: string;
}

export interface TaskInstance {
  id: string;
  status: TaskStatus;
  note: string;
  updatedAt: string | null;
  updatedBy: string | null;
  source: 'catalog' | 'action';
  actionMeta?: ActionMeta;
  filterSnapshot?: Record<string, string[]>;
}

export function createTaskInstance(
  id: string,
  overrides?: Partial<TaskInstance>
): TaskInstance {
  return {
    id,
    status: 'unverified',
    note: '',
    updatedAt: null,
    updatedBy: null,
    source: 'catalog',
    ...overrides,
  };
}

export function createActionTask(
  category: string,
  label: string,
  description: string,
  previousValue?: string,
  newValue?: string
): TaskInstance {
  const id = `action-${category}-${Date.now()}-${Math.round(
    Math.random() * 100_000
  )}`;
  return {
    id,
    status: 'unverified',
    note: '',
    updatedAt: null,
    updatedBy: null,
    source: 'action',
    actionMeta: {
      category,
      label,
      description,
      previousValue,
      newValue,
    },
  };
}
